/** Mobile — used for WhatsApp and as the primary click-to-call number in the header. */
export const PHONE_MOBILE_DISPLAY = "647 549 6441";
/** Office line */
export const PHONE_OFFICE_DISPLAY = "647 564 6441";

/** Digits only (after country code 1) for wa.me: 1 + 6475496441 */
export const PHONE_MOBILE_E164 = "16475496441";
export const PHONE_OFFICE_E164 = "16475646441";

export const WHATSAPP_URL = `https://wa.me/${PHONE_MOBILE_E164}`;

/** Clickable tel: links (Canada +1) */
export const PHONE_MOBILE_HREF = `tel:+${PHONE_MOBILE_E164}`;
export const PHONE_OFFICE_HREF = `tel:+${PHONE_OFFICE_E164}`;

/** Build tel: from a display string like "647 549 6441" */
export function telHrefFromDisplay(display: string): string {
  const digits = display.replace(/\D/g, "");
  if (digits.length === 10) return `tel:+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `tel:+${digits}`;
  return `tel:${display}`;
}
